export default {
  noDashboards: '{asset} verfügt über keine Dashboards.',
  noWidgets: '{dashboard} hat keine Widgets.',
  addDashboard: 'Dashboard erstellen',
  addWidget: 'Widget hinzufügen',
};
